var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKiaLanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 699.3 256.4",
    style: {
      enableBackground: "new 0 0 699.3 256.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#05141F;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 699,
    height: 256.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.1,180.8c0,1.1,0.3,1.7,1,1.7c0.5,0,0.9-0.2,1.4-0.5L578.9,64.7c3.2-2.1,6.1-3.2,10.4-3.2H629 c6.1,0,10.2,4.1,10.2,10.2v75.7c0,9.1-2,14.4-10.2,19.3l-48.1,28.9c-0.6,0.4-1.2,0.6-1.6,0.6c-0.6,0-1.1-0.4-1.1-2.1v-88.4 c0-1-0.3-1.7-1-1.7c-0.5,0-0.9,0.2-1.4,0.5l-131.9,85.7c-3.7,2.4-6.7,3.1-10.1,3.1h-87.5c-6.1,0-10.2-4.1-10.2-10.2v-109 c0-0.8-0.4-1.5-1-1.5c-0.5,0-0.9,0.2-1.4,0.5l-87,52.3c-0.9,0.5-1.1,1-1.1,1.4s0.1,0.7,0.8,1.3l62.1,62.1c0.8,0.8,1.4,1.5,1.4,2.1 c0,0.7-0.9,1.1-2,1.1h-56.2c-4.4,0-7.8-0.7-10.2-3.1l-37.7-37.7c-0.4-0.4-0.7-0.6-1.1-0.6c-0.3,0-0.8,0.2-1.2,0.4l-63,37.9 c-3.8,2.3-6.4,3-10.2,3h-58c-6.1,0-10.2-4.1-10.2-10.2v-74.3c0-9.2,2-14.4,10.2-19.3l48.4-29.1c0.5-0.3,0.9-0.4,1.3-0.4 c0.7,0,1.1,0.8,1.1,2.4v99.4c0,1,0.3,1.5,1,1.5c0.4,0,0.9-0.3,1.4-0.6L287,64.4c3.9-2.3,6.3-3,10.8-3h88c6.1,0,10.2,4.1,10.2,10.2 L396.1,180.8L396.1,180.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiaLanding);
export default __webpack_public_path__ + "static/media/KiaLanding.e863cb4f.svg";
export { ForwardRef as ReactComponent };